import React, { ReactElement } from "react";

import { StockLevels } from "@utils/enums";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import Stock from "@components/Store/StoreDetails/stock.component";

import { TProductAvailability } from "lib/@types/service/store/shared";

type Props = {
    productAvailability: TProductAvailability;
    shopName?: string;
};

const ItemStock = ({ productAvailability, shopName }: Props): ReactElement => {
    const { t } = useGranite();
    return (
        <div
            className="mb-2"
            style={{
                opacity:
                    productAvailability?.stockLevel === StockLevels.NoStock ||
                    productAvailability?.stockLevel === StockLevels.UnknownStock
                        ? "0.5"
                        : "1",
            }}
        >
            {shopName && (
                <div className="small font-weight-bold">
                    {t("ecommerce.label.pickup.preferredStore", shopName)}
                </div>
            )}
            <div className="small text-NONE">
                <Stock productAvailability={productAvailability} />
            </div>
        </div>
    );
};

export default ItemStock;
